<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 3.5C17.5 2.94772 17.0523 2.5 16.5 2.5H3.5C2.94772 2.5 2.5 2.94772 2.5 3.5V16.5C2.5 17.0523 2.94772 17.5 3.5 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5V3.5ZM9.16667 15.8333H4.16667V7.5H9.16667V15.8333ZM4.16667 5.83333H9.16667V4.16667H4.16667V5.83333ZM15.8333 15.8333H10.8333V7.5H15.8333V15.8333ZM10.8333 5.83333H15.8333V4.16667H10.8333V5.83333Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>

</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
